
// src/actions/kpi.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'
import moment from 'moment'

export const FETCH_DIARY_KPI = "FETCH_DIARY_KPI"
export const FETCH_DIARY_KPI_REQUESTED = "FETCH_DIARY_KPI_REQUESTED"
export const FETCH_DIARY_KPI_COMPLETED = "FETCH_DIARY_KPI_COMPLETED"
export const FETCH_DIARY_KPI_FAILED = "FETCH_DIARY_KPI_FAILED"

export function fetchDiaryKpiRequested() {
  return {
    type: FETCH_DIARY_KPI_REQUESTED
  }
}

export function fetchDiaryKpi(group_id, reported_at) {
  return function(dispatch) {
    dispatch(fetchDiaryKpiRequested())
    return api.get(`/kpi_status`, { group_id, reported_at: moment(reported_at).format('YYYY-MM-DD') })
        .then((results)=> {
          dispatch(fetchDiaryKpiCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchDiaryKpiFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchDiaryKpiCompleted(results) {
  return {
    type: FETCH_DIARY_KPI_COMPLETED,
    results,
  }
}

export function fetchDiaryKpiFailed(error) {
  return {
    type: FETCH_DIARY_KPI_FAILED,
    error,
  }
}

export const FETCH_CLOSED_KPIS = "FETCH_CLOSED_KPIS"
export const FETCH_CLOSED_KPIS_REQUESTED = "FETCH_CLOSED_KPIS_REQUESTED"
export const FETCH_CLOSED_KPIS_COMPLETED = "FETCH_CLOSED_KPIS_COMPLETED"
export const FETCH_CLOSED_KPIS_FAILED = "FETCH_CLOSED_KPIS_FAILED"

export function fetchClosedKpisRequested() {
  return {
    type: FETCH_CLOSED_KPIS_REQUESTED
  }
}

export function fetchClosedKpis(group_id, offset) {
  return function(dispatch) {
    dispatch(fetchClosedKpisRequested())
    return api.get(`/kpi`, { group_id, offset, status: 'closed' })
        .then((results)=> {
          dispatch(fetchClosedKpisCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchClosedKpisFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchClosedKpisCompleted(results, offset) {
  return {
    type: FETCH_CLOSED_KPIS_COMPLETED,
    results, offset,
  }
}

export function fetchClosedKpisFailed(error) {
  return {
    type: FETCH_CLOSED_KPIS_FAILED,
    error,
  }
}

export const FETCH_KPIS = "FETCH_KPIS"
export const FETCH_KPIS_REQUESTED = "FETCH_KPIS_REQUESTED"
export const FETCH_KPIS_COMPLETED = "FETCH_KPIS_COMPLETED"
export const FETCH_KPIS_FAILED = "FETCH_KPIS_FAILED"

export function fetchKpisRequested() {
  return {
    type: FETCH_KPIS_REQUESTED
  }
}

export function fetchKpis(group_id, status = 'working') {

  return function(dispatch) {
    dispatch(fetchKpisRequested())
    return api.get(`/kpi`, { group_id, status, length: 500 })
        .then((results)=> {
          dispatch(fetchKpisCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchKpisFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchKpisCompleted(results) {
  return {
    type: FETCH_KPIS_COMPLETED,
    results,
  }
}

export function fetchKpisFailed(error) {
  return {
    type: FETCH_KPIS_FAILED,
    error,
  }
}

export const FETCH_CHART_KPIS = "FETCH_CHART_KPIS"
export const FETCH_CHART_KPIS_REQUESTED = "FETCH_CHART_KPIS_REQUESTED"
export const FETCH_CHART_KPIS_COMPLETED = "FETCH_CHART_KPIS_COMPLETED"
export const FETCH_CHART_KPIS_FAILED = "FETCH_CHART_KPIS_FAILED"

export function fetchChartKpisRequested() {
  return {
    type: FETCH_CHART_KPIS_REQUESTED
  }
}

export function fetchChartKpis(group_id, start_date = moment().format('YYYY-MM-DD'), end_date = moment().format('YYYY-MM-DD'), selected_kpis=[]) {

  return function(dispatch) {
    dispatch(fetchChartKpisRequested())
    // Flatten selected_kpis into multiple query parameters
    const selectedKpisQuery = selected_kpis
      .map((kpi, index) => `selected_kpis[${index}][kpi_id]=${kpi.kpi_id}`)
      .join('&');

    const queryParams = `group_id=${group_id}&start_date=${start_date}&end_date=${end_date}&${selectedKpisQuery}`;

    return api.get(`/kpi/chart_kpis?${queryParams}`)
        .then((results)=> {
          dispatch(fetchChartKpisCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchChartKpisFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchChartKpisCompleted(results) {
  return {
    type: FETCH_CHART_KPIS_COMPLETED,
    results,
  }
}

export function fetchChartKpisFailed(error) {
  return {
    type: FETCH_CHART_KPIS_FAILED,
    error,
  }
}

export const FETCH_GROUP_KPIS = "FETCH_GROUP_KPIS"
export const FETCH_GROUP_KPIS_REQUESTED = "FETCH_GROUP_KPIS_REQUESTED"
export const FETCH_GROUP_KPIS_COMPLETED = "FETCH_GROUP_KPIS_COMPLETED"
export const FETCH_GROUP_KPIS_FAILED = "FETCH_GROUP_KPIS_FAILED"

export function fetchGroupKpisRequested() {
  return {
    type: FETCH_GROUP_KPIS_REQUESTED
  }
}

export function fetchGroupKpis(group_id) {

  return function(dispatch) {
    dispatch(fetchGroupKpisRequested())
    return api.get(`/kpi/group_kpis`, { group_id })
        .then((results)=> {
          dispatch(fetchGroupKpisCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchGroupKpisFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchGroupKpisCompleted(results) {
  return {
    type: FETCH_GROUP_KPIS_COMPLETED,
    results,
  }
}

export function fetchGroupKpisFailed(error) {
  return {
    type: FETCH_GROUP_KPIS_FAILED,
    error,
  }
}

export const FETCH_COMPARISON_KPIS = "FETCH_COMPARISON_KPIS"
export const FETCH_COMPARISON_KPIS_REQUESTED = "FETCH_COMPARISON_KPIS_REQUESTED"
export const FETCH_COMPARISON_KPIS_COMPLETED = "FETCH_COMPARISON_KPIS_COMPLETED"
export const FETCH_COMPARISON_KPIS_FAILED = "FETCH_COMPARISON_KPIS_FAILED"

export function fetchComparisonKpisRequested() {
  return {
    type: FETCH_COMPARISON_KPIS_REQUESTED
  }
}

export function fetchComparisonKpis(selected_kpis=[], group_id) {

  return function(dispatch) {
    dispatch(fetchComparisonKpisRequested())
    // Flatten selected_kpis into multiple query parameters
    const selectedKpisQuery = selected_kpis
      .map((kpi, index) => `selected_kpis[${index}][kpi_id]=${kpi.kpi_id}&selected_kpis[${index}][year]=${kpi.year}`)
      .join('&');

    const queryParams = `group_id=${group_id}&${selectedKpisQuery}`;

    return api.get(`/kpi/comparison_kpis?${queryParams}`)
        .then((results)=> {
          dispatch(fetchComparisonKpisCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchComparisonKpisFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchComparisonKpisCompleted(results) {
  return {
    type: FETCH_COMPARISON_KPIS_COMPLETED,
    results,
  }
}

export function fetchComparisonKpisFailed(error) {
  return {
    type: FETCH_COMPARISON_KPIS_FAILED,
    error,
  }
}

export const FETCH_KPI = "FETCH_KPI"
export const FETCH_KPI_REQUESTED = "FETCH_KPI_REQUESTED"
export const FETCH_KPI_COMPLETED = "FETCH_KPI_COMPLETED"
export const FETCH_KPI_FAILED = "FETCH_KPI_FAILED"

export function fetchKpiRequested() {
  return {
    type: FETCH_KPI_REQUESTED
  }
}

export function fetchKpi(kpi_id) {
  return function(dispatch) {
    dispatch(fetchKpiRequested())
    return api.get(`/kpi/${kpi_id}`, {})
        .then((results)=> {
          dispatch(fetchKpiCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchKpiFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchKpiCompleted(results) {
  return {
    type: FETCH_KPI_COMPLETED,
    results,
  }
}

export function fetchKpiFailed(error) {
  return {
    type: FETCH_KPI_FAILED,
    error,
  }
}

export const CREATE_KPI = "CREATE_KPI"
export const CREATE_KPI_REQUESTED = "CREATE_KPI_REQUESTED"
export const CREATE_KPI_COMPLETED = "CREATE_KPI_COMPLETED"
export const CREATE_KPI_FAILED = "CREATE_KPI_FAILED"

export function createKpiRequested() {
  return {
    type: CREATE_KPI_REQUESTED
  }
}

export function createKpi(name, unit, group_id, start_date, end_date, generate_next_at_days, display_format, prepend_unit, accumulated_total, assignments) {
  return function(dispatch) {
    dispatch(createKpiRequested())
    return api.post(`/kpi`, { name, unit, group_id, start_date, end_date, generate_next_at_days, display_format, prepend_unit, accumulated_total, assignments })
        .then((results)=> {
          dispatch(createKpiCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(createKpiFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function createKpiCompleted(results) {
  return {
    type: CREATE_KPI_COMPLETED,
    results,
  }
}

export function createKpiFailed(error) {
  return {
    type: CREATE_KPI_FAILED,
    error,
  }
}

export const UPDATE_KPI = "UPDATE_KPI"
export const UPDATE_KPI_REQUESTED = "UPDATE_KPI_REQUESTED"
export const UPDATE_KPI_COMPLETED = "UPDATE_KPI_COMPLETED"
export const UPDATE_KPI_FAILED = "UPDATE_KPI_FAILED"

export function updateKpiRequested() {
  return {
    type: UPDATE_KPI_REQUESTED
  }
}

export function updateKpi(kpi_id, name, unit, group_id, start_date, end_date, generate_next_at_days, display_format, prepend_unit, accumulated_total, assignments) {
  return function(dispatch) {
    dispatch(updateKpiRequested())
    return api.put(`/kpi/${kpi_id}`, { name, unit, group_id, start_date, end_date, generate_next_at_days, display_format, prepend_unit, accumulated_total, assignments })
        .then((results)=> {
          dispatch(updateKpiCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateKpiFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateKpiCompleted(results) {
  return {
    type: UPDATE_KPI_COMPLETED,
    results,
  }
}

export function updateKpiFailed(error) {
  return {
    type: UPDATE_KPI_FAILED,
    error,
  }
}

export const DELETE_KPI = "DELETE_KPI"
export const DELETE_KPI_REQUESTED = "DELETE_KPI_REQUESTED"
export const DELETE_KPI_COMPLETED = "DELETE_KPI_COMPLETED"
export const DELETE_KPI_FAILED = "DELETE_KPI_FAILED"

export function deleteKpiRequested() {
  return {
    type: DELETE_KPI_REQUESTED
  }
}

export function deleteKpi(kpi_id) {
  return function(dispatch) {
    dispatch(deleteKpiRequested())
    return api.delete(`/kpi/${kpi_id}`)
        .then((results)=> {
          dispatch(deleteKpiCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deleteKpiFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deleteKpiCompleted(results) {
  return {
    type: DELETE_KPI_COMPLETED,
    results,
  }
}

export function deleteKpiFailed(error) {
  return {
    type: DELETE_KPI_FAILED,
    error,
  }
}

export const SORT_KPIS = "SORT_KPIS"
export const SORT_KPIS_REQUESTED = "SORT_KPIS_REQUESTED"
export const SORT_KPIS_COMPLETED = "SORT_KPIS_COMPLETED"
export const SORT_KPIS_FAILED = "SORT_KPIS_FAILED"

export function sortKpisRequested() {
  return {
    type: SORT_KPIS_REQUESTED
  }
}

export function sortKpis(sort_order, group_id) {
  return function(dispatch) {
    dispatch(sortKpisRequested())
    return api.put(`/kpi/sort`, { sort_order, group_id, length: sort_order.length })
        .then((results)=> {
          dispatch(sortKpisCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(sortKpisFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function sortKpisCompleted(results) {
  return {
    type: SORT_KPIS_COMPLETED,
    results,
  }
}

export function sortKpisFailed(error) {
  return {
    type: SORT_KPIS_FAILED,
    error,
  }
}

export const CLEAR_KPIS = "CLEAR_KPIS"

export function clearKpis() {
  return {
    type: CLEAR_KPIS
  }
}

export const CLEAR_DIARY_KPI = "CLEAR_DIARY_KPI"

export function clearDiaryKpi() {
  return {
    type: CLEAR_DIARY_KPI
  }
}

export const CLEAR_CLOSED_KPIS = "CLEAR_CLOSED_KPIS" 

export function clearClosedKpis() {
  return {
    type: CLEAR_CLOSED_KPIS,
  }
}

export const KEEP_SCROLL_POSITION = "KEEP_SCROLL_POSITION"

export function keepScrollPosition(offset) {
  return {
    type: KEEP_SCROLL_POSITION,
    offset
  }
}



// WEBPACK FOOTER //
// ./src/actions/kpi.js